import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IBackupSettingsState } from '../reducers/backup-settings.reducer';
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBackupSettingsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.backupSettings);


export const getBackupSettings = (websiteId: number) =>
  createSelector(getBackupSettingsState, (state: IBackupSettingsState) =>
    state.entities[websiteId] ? state.entities[websiteId].entities : null
  );
